module.exports = __webpack_public_path__ + "static/media/2_pl.b6fa821f.png";